import { Navigate } from "react-router-dom";
import { ROLE_LOGISTIC, ROLE_SELLER } from "../Config/config";
import { getLocalStorageItem } from "../Helper/helper";

const PrivateSellerRoute = ({ children }) => {
	const userDetails = getLocalStorageItem("ORDER_USER_DETAILS");
	const role = userDetails?.role || localStorage.getItem("ORDER_USER_ROLE");
	const AUTH_TOKEN = getLocalStorageItem("ORDER_AUTH_TOKEN");

	if (AUTH_TOKEN) {
		if (role == ROLE_SELLER || role == 5 || role == "5") {
			return children;
		} else {
			return <Navigate to="/access-denied" />;
		}
	} else {
		return <Navigate to="/login" />;
	}
};
export default PrivateSellerRoute;
